import { render, staticRenderFns } from "./planning-body-slot.vue?vue&type=template&id=62d3c67f&scoped=true&functional=true"
import script from "./planning-body-slot.vue?vue&type=script&lang=js"
export * from "./planning-body-slot.vue?vue&type=script&lang=js"
import style0 from "./planning-body-slot.vue?vue&type=style&index=0&id=62d3c67f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "62d3c67f",
  null
  
)

export default component.exports